import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import type { LoyaltyApiError, VouchersResponse } from '~/lib/data-contract/loyalty';
import { QueryKeys } from '~/services/loyalty/constants';
import type { AllowedOptions } from '../allowedQueryOptions';
import { useLoyaltyContext } from '..';

export const useVouchers = <TData = VouchersResponse>(
    options?: AllowedOptions<VouchersResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<VouchersResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.VOUCHERS],
        queryFn: createLoyaltyQuery('GetVouchers', translate, trackError, {
            memberId: businessCentralId,
        }),
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
